const STEPS = [
  {
    n: "01",
    title: "Tell us about your app",
    body: "Describe what you built in plain language, or just connect your repo. We detect your stack and figure out what it needs."
  },
  {
    n: "02",
    title: "Connect your code",
    body: "Link a GitHub repo, or we'll walk you through pushing your local project. Takes a few minutes."
  },
  {
    n: "03",
    title: "We provision your server",
    body: "A dedicated server (from $4/mo) is created on your cloud account - yours alone, no shared resources."
  },
  {
    n: "04",
    title: "You get a live URL",
    body: "We wire up HTTPS, monitoring and auto-deploys on every git push. You get a production URL to share. That's it."
  }
];

export const HowItWorks = () => (
  <section id="how" className="max-w-[1140px] mx-auto px-8 py-24">
    <div className="max-w-[720px] mx-auto text-center mb-14">
      <div className="inline-block text-xs text-primary bg-primary/8 px-3 py-1 rounded-full mb-4 font-medium tracking-wide lowercase font-mono">
        how it works
      </div>
      <h2 className="font-serif text-[clamp(36px,5.5vw,56px)] leading-[1.05] tracking-tight font-normal mb-4 text-foreground text-balance">
        From GitHub repo to <em className="text-primary">production</em>, in four steps.
      </h2>
      <p className="text-[17px] leading-relaxed text-muted-foreground text-pretty">
        We handle the infrastructure and explain anything you want to understand. No Docker, no
        Terraform, no SSH.
      </p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3.5">
      {STEPS.map(s => (
        <div
          key={s.n}
          className="bg-card border rounded-xl p-7 shadow-sm hover:-translate-y-0.5 hover:shadow-md transition-all"
        >
          <div className="font-mono text-[22px] font-semibold text-primary bg-primary/8 inline-block px-2 py-0.5 rounded-md mb-4">
            {s.n}
          </div>
          <div className="text-[17px] font-semibold mb-2 tracking-tight">{s.title}</div>
          <div className="text-sm leading-relaxed text-muted-foreground">{s.body}</div>
        </div>
      ))}
    </div>
  </section>
);
